import { showPopup } from '@/functions/popup';

export function getToken(callback) {
  callback(localStorage.getItem('token'));
}

export function setToken(token, callback) {
  localStorage.setItem('token', token);
  callback();
}

export function removeToken() {
  localStorage.removeItem('token');
  reloadApp();
}

function reloadApp() {
  const PLATFORM = window?.WebApp?.initDataUnsafe?.user?.id
    ? 'MAX'
    : window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
      ? 'TELEGRAM'
      : null;
  showPopup(
    'Время сессии истекло. Пожалуйста, авторизуйтесь повторно.',
    '',
    () => {
      if (PLATFORM === 'MAX') {
        if (window?.WebApp) {
          window.WebApp.close();
        }
      } else if (PLATFORM === 'TELEGRAM') {
        if (window?.Telegram?.WebApp) {
          window.Telegram.WebApp.close();
        }
      }
    },
  );
}
